module.exports = __webpack_public_path__ + "b00849e00f4c2331cddd8ffb44a6720b.woff";